import type { PostFields } from '@tribeplatform/gql-client/graphql'
import type { ClientError } from '@tribeplatform/gql-client/lib'
import {
  MutationCreateDraftPostArgs,
  Post,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import {
  getDraftPostsCountKey,
  getDraftPostsKey,
} from '../../utils/keys/post.key.js'

export const useCreateDraftPost = (options?: {
  fields?: PostFields
  useMutationOptions?: UseMutationOptions<
    Post,
    ClientError,
    MutationCreateDraftPostArgs
  >
}) => {
  const { useMutationOptions, fields = 'default' } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Post, ClientError, MutationCreateDraftPostArgs>(
    (input: MutationCreateDraftPostArgs) =>
      client.posts.createDraftPost(input, fields),

    {
      onSuccess: (data, variables, ctx) => {
        queryClient.invalidateQueries(getDraftPostsKey())
        queryClient.invalidateQueries(getDraftPostsCountKey())

        if (useMutationOptions?.onSuccess) {
          useMutationOptions.onSuccess(data, variables, ctx)
        }
      },
      ...useMutationOptions,
    },
  )
}
